import gsap from 'gsap';

import { AnimationRefs } from '../hooks/use-animation-refs';
import { Viewport } from '../hooks/use-viewport';
import { buildStage1 } from './main/stages/stage1';
import { buildStage2 } from './main/stages/stage2';
import { buildStage3 } from './main/stages/stage3';
import { buildStage4 } from './main/stages/stage4';
import { buildStage5 } from './main/stages/stage5';
import { buildStage6 } from './main/stages/stage6';
import { buildStage7 } from './main/stages/stage7';
import { buildStage8 } from './main/stages/stage8';
import { buildStage9 } from './main/stages/stage9';
import { buildStage10 } from './main/stages/stage10';
import { buildStage11 } from './main/stages/stage11';
import { buildStage12 } from './main/stages/stage12';
import { buildStage13 } from './main/stages/stage13';
import { build } from './points-screen/stages/stage1';

export function createMainTimeline(refs: AnimationRefs, viewport: Viewport) {
  const tl = gsap.timeline({
    paused: true,
  });

  buildStage1(tl, refs, viewport);
  buildStage2(tl, refs, viewport);
  buildStage3(tl, refs, viewport);
  buildStage4(tl, refs, viewport);
  buildStage5(tl, refs, viewport);
  buildStage6(tl, refs, viewport);
  buildStage7(tl, refs, viewport);
  buildStage8(tl, refs, viewport);
  buildStage9(tl, refs, viewport);
  buildStage10(tl, refs, viewport);
  buildStage11(tl, refs, viewport);
  buildStage12(tl, refs, viewport);
  buildStage13(tl, refs, viewport);

  return tl;
}

export function createPointsScreenTimeline(refs: AnimationRefs, viewport: Viewport) {
  const tl = gsap.timeline({
    paused: true,
  });

  build(tl, refs, viewport);

  return tl;
}
